export enum UserAccessPatrimoineEnum {
  toutPatrimoine = 'tout le patrimoine',
  accessPatrimoine = 'liste personnalisée'
}
